@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
      <h3 style="margin: 0;">MailChimp Integration</h3>
      <button pButton type="button"
        class="p-button-outlined" (click)="goBack()"><span class="p-button-icon p-button-icon-left pi pi-arrow-left" aria-hidden="true"></span><span class="p-button-label">Back to Integrations</span></button>
      </div>
      <div class="surface-card p-4 shadow-2 border-round">
        <div class="grid formgrid p-fluid">
          <!-- MailChimp Enabled Toggle -->
          <div class="field mb-4 col-12">
            <label class="font-medium">MailChimp Enabled</label>
            <div class="mt-2">
              <p-selectbutton style="width:350px;display:block;" [(ngModel)]="mailchimpEnabled" [options]="mailchimpStateOptions"
                (onChange)="onMailChimpEnabledChange()" optionLabel="label" optionValue="value">
              </p-selectbutton>
            </div>
          </div>
          <!-- API Key Field (only shown when enabled) -->
          @if (mailchimpEnabled) {
            <div class="field mb-4 col-12">
              <label for="apiKey" class="font-medium">API Key</label>
              <input id="apiKey" [(ngModel)]="apiKey" pInputText
                placeholder="Enter your MailChimp API key"
                style="width: 100%; display: block;">
              </div>
            }
            <!-- Save Button -->
            @if (mailchimpEnabled) {
              <div class="field mb-4 col-12">
                <button style="width:350px;" pButton type="button"
                  [loading]="settingsSaving"
                  (click)="saveSettings()"
                  class="p-button-success"
                  [disabled]="settingsSaving || !apiKey">@if (settingsSaving) {
                  <span class="p-button-icon p-button-loading-icon pi pi-spin pi-spinner" aria-hidden="true"></span>
                }
                <i class="pi pi-save" style="margin-right: 8px;"></i>
                Save Settings
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  }

  <p-toast></p-toast>
